module.exports = __webpack_public_path__ + "img/service-icon-mixer.6fca4cef.png";